{
  "fr": {
    "join": {
      "heading": "Bienvenue sur fobizz",
      "paragraph": "Activez l'accès à votre groupe de licence. Vous recevrez le code de la personne responsable de votre établissement.",
      "button": "Activer",
      "back": "Aller au contenu",
      "autoSubmitting": "Activation de la licence en cours …"
    }
  }
}
